import { Indicator } from '../../../Common/Charts/Indicator';
import { useDatabaseChartsDataContext } from './hooks/useDatabaseChartsDataContext';

export const RegisterUpdateIndicator = () => {
    const { chartData } = useDatabaseChartsDataContext();

    return (
        <Indicator
            title={'Indice de Atualização Cadastral'}
            indicatorValue={chartData?.indicators?.registerUpdate}
            className='aligned-container'
        />
    );
};
